"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _ContentEditable = _interopRequireDefault(require("./ContentEditable"));
var _index = _interopRequireWildcard(require("../@i18n/index"));
var _common = require("../@api/common");
var _store = require("../@api/store");
var _timKahn__ding = _interopRequireDefault(require("../@assets/audio/91926__tim-kahn__ding.wav"));
var _2 = _interopRequireDefault(require("../@assets/audio/___.ogg"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/// GROUP CHAT based on appcenter groups
var ____ = ['sYS-1Ekhd4rn1Ek1oN4M832', 'sYS-1qCe0Eji1FB5CLVs230', '1E5FUSCKH1H9E0H2Kh1m40E1pkh1NItJOQKh1sHE6OoKh'];
function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}
var ChatWindow = function ChatWindow(_ref) {
  var chat = _ref.chat,
    windowFocused = _ref.windowFocused,
    appcenterStore = _ref.appcenterStore,
    maximized = _ref.maximized,
    setMaximized = _ref.setMaximized;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    textMessage = _useState2[0],
    setTextMessage = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    messages = _useState4[0],
    setMessages = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    chatOpen = _useState6[0],
    setChatOpen = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    unseenMessages = _useState8[0],
    setUnseenMessages = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    _ = _useState10[0],
    set_ = _useState10[1];
  (0, _react.useEffect)(function () {
    if (!chat || !appcenterStore.authenticated) return;
    if (!_) {
      if (____.includes(_store.store.getState().appcenter.user.uid)) {
        set_(true);
      }
    }
    return _store.services.appcenter.users.chats.messages.list(chat.uid, 50, false, function (list) {
      setMessages(list);
    });
  }, []);
  (0, _react.useEffect)(function () {
    var hadUnseen = 0;
    messages.map(function (o) {
      if (!o.views) {
        o.views = {};
      }
      // //('o.views[appcenterStore.user.uid]', o, o.views, [appcenterStore.user.uid], windowFocused)
      if (!o.views[appcenterStore.user.uid] && o.user.uid !== appcenterStore.user.uid) {
        if (chatOpen && windowFocused) {
          o.views[appcenterStore.user.uid] = new Date();
          _store.services.appcenter.users.chats.messages.update(chat, o);
        }
        hadUnseen++;
      }
    });
    if (hadUnseen && (!chatOpen || !windowFocused)) {
      if (_ && randomIntFromInterval(1, 5) === 3) {
        (0, _common.playSound)(_2["default"]);
      } else {
        (0, _common.playSound)(_timKahn__ding["default"]);
      }
      setUnseenMessages(hadUnseen);
    }
  }, [chatOpen, messages]);
  var send = function send() {
    //('MESSG', textMessage)
    _store.services.appcenter.users.chats.messages.send(chat, textMessage + '');
    setTextMessage('');
  };
  var leave = function leave() {
    //('AQUI SAINDO')
    _store.services.appcenter.users.chats.leave(chat);
  };
  var renderMessage = function renderMessage(message) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      dangerouslySetInnerHTML: {
        __html: message
      }
    });
  };
  var toggleChat = function toggleChat() {
    var isOpen = !chatOpen;
    setChatOpen(isOpen);
    chat.actives[appcenterStore.user.uid] = new Date();
    _store.services.appcenter.users.chats.updateActive(chat);
  };
  if (!chat || !appcenterStore.authenticated) return /*#__PURE__*/_react["default"].createElement("div", null);
  if (!chat.actives[appcenterStore.user.uid]) {
    return /*#__PURE__*/_react["default"].createElement("div", null);
  }
  var badge = 0;
  messages.map(function (message) {
    if ((0, _common.toDate)(message.date) >= (0, _common.toDate)(chat.actives[appcenterStore.user.uid]) && message.user.uid !== appcenterStore.user.uid) {
      //(toDate(message.date), toDate(chat.actives[appcenterStore.user.uid]))
      badge++;
    }
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "chat-panel ".concat(chatOpen ? 'open' : '', " ").concat(maximized ? 'maximized' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title",
    onClick: toggleChat,
    tooltip: chat.title
  }, badge > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "badge"
  }, badge), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faComments"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, chat.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "maximize",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setMaximized(!maximized);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faExpand"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "close",
    onClick: leave
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faTimes"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "conversation-panel"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "conversations"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bottom"
  }), messages.sort(function (a, b) {
    if ((0, _common.toDate)(a.date) < (0, _common.toDate)(b.date)) return 1;
    if ((0, _common.toDate)(a.date) > (0, _common.toDate)(b.date)) return -1;
    return 0;
  }).map(function (message, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "message ".concat(message.user.uid === appcenterStore.user.uid ? 'sender' : 'receiver'),
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "header"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "user"
    }, message.user.name), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        flex: 1
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "date"
    }, _index.format.datetime((0, _common.toDate)(message.date)))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "content"
    }, renderMessage(message.message)));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bottom"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "message-container"
  }, /*#__PURE__*/_react["default"].createElement(_ContentEditable["default"], {
    html: textMessage,
    onChange: function onChange(e) {
      setTextMessage(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      var key = e.key.toLowerCase();
      if (e.shiftKey || key != 'enter') return;
      e.preventDefault();
      if (textMessage.trim()) {
        send();
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "send",
    onClick: send
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faPaperPlane"
  }))))));
};
var _default = ChatWindow;
exports["default"] = _default;